const urlMidd               = '/api/v0'
const juliaDataAnalyticsUrl = '/bda/v0'
const pythonDataAnalyticsUrl= '/pbda/v0'

const ZOHO_AUTH             = `${urlMidd}/zoho`
const REGISTER_USER         = `${urlMidd}/register`
const RESEND_VERIFICATION   = `${urlMidd}/sendEmailVerificationLink`
const READ_BASIC_USER_DATA  = `${urlMidd}/emailVerificationStatus`
const READ_USER_NAME        = `${urlMidd}/userFullName`

const LOGOUT_USER           = `${urlMidd}/revokeSession`
const GET_ALL_USER          = `${urlMidd}/users`
const DELETE_USER           = `${urlMidd}/users/:id`
const USER_PROFILE_PATH     = `${urlMidd}/users/:id`
const PATCH_USER_DETAILS    = `${urlMidd}/users/:id`
const RESET_PASSWORD        = `${urlMidd}/resetPassword`

const SHARED_DETAILS        =`${urlMidd}/sharesWithOther`

const ADD_CLUSTER           = `${urlMidd}/clusters`
const READ_CLUSTER_DATA     = `${urlMidd}/clusters`
const EDIT_CLUSTERS         = (clusterId) => `${urlMidd}/clusters/${clusterId}`
const MANAGE_CLUSTER_ARCHIVAL       = (clusterId) => `${urlMidd}/clusters/${clusterId}/archival`
const MANAGE_CLUSTER_FAVOURITE = (clusterId) => `${urlMidd}/clusters/${clusterId}/favourite`
const OPT_OUT_SHARED_CLUSTER = (clusterId) => `${urlMidd}/clusters/${clusterId}/opt-out`
const READ_PROJECTS_CLUST   = (clusterId) => `${urlMidd}/clusters/${clusterId}`
const SHARE_CLUSTER         = `${urlMidd}/shareclusters`
const UPDATE_SHARE_CLUSTER  = (clusterId) => `${urlMidd}/shares/cluster/${clusterId}`
const DELETE_SHARE_CLUSTER  = `${urlMidd}/shares/cluster`

const SHARE_REPORT          = `${urlMidd}/sharereports`
const UPDATE_SHARE_REPORT   = `${urlMidd}/shares/reports`
const DELETE_SHARE_REPORT   = `${urlMidd}/shares/report`


const CLUSTER_OWNER_DATA = `${urlMidd}/clusterOwnerDetails`
const ADD_PROJECTS          = (clusterId) => `${urlMidd}/clusters/${clusterId}/project`
const EDIT_PROJECTS         = (clusterId, projectId) => `${urlMidd}/projects/${clusterId}/${projectId}`
const READ_REPORTS_PROJ     = (clusterId, projectId) => `${urlMidd}/clusters/${clusterId}/projects/${projectId}`

//const REQUEST_ENTITY_SHARE = `${urlMidd}/requestEntityShare`
const REQUEST_ENTITY_SHARE = `${urlMidd}/resourceAccessRequests`
const ADD_REPORT            = (clusterId, projectId, reportType) => `${urlMidd}/projects/${clusterId}/${projectId}/${reportType}`
const UPDATE_REPORT         = (clusterId, projectId, reportId) => `${urlMidd}/clusters/${clusterId}/projects/${projectId}/reports/${reportId}/reportDetails`
const READ_REPORT           = (clusterId, projectId, reportId) => `${urlMidd}/reports/${clusterId}/${projectId}/${reportId}`
const DELETE_REPORT         = (clusterId, projectId, reportId) => `${urlMidd}/reports/${clusterId}/${projectId}/${reportId}`

const ADD_TEMPLATE          = (clusterId, projectId) => `${urlMidd}/templates/${clusterId}/${projectId}/template`
const UPDATE_TEMPLATE       = (clusterId, projectId, templateId) => `${urlMidd}/templates/${clusterId}/${projectId}/${templateId}`
const REMOVE_TEMPLATE       = (clusterId, projectId, templateId) => `${urlMidd}/templates/${clusterId}/${projectId}/${templateId}`
const FILES_TEMPLATE        = (clusterId, projectId) => `${urlMidd}/getFiles/${clusterId}/${projectId}/template`
const READ_TEMPLATES_PROJ   = (clusterId, projectId) => `${urlMidd}/templates/${clusterId}/${projectId}/templates`
const GET_READ_TEMPLATE     = (clusterId, projectId, templateId) => `${urlMidd}/templates/${clusterId}/${projectId}/${templateId}`

const ADD_RAW_FILE          = (clusterId, projectId, reportId) => `${urlMidd}/upload/${clusterId}/${projectId}/${reportId}`
const DOWNLOAD_RAW_FILES    = (clusterId, projectId, reportId) => `${urlMidd}/getFilesDirect/${clusterId}/${projectId}/${reportId}/report`

const BINARY_FILES_DATA_EXTRACTION=`${pythonDataAnalyticsUrl}/openDT6`
const GET_SVG_CIRCUIT_DRAW  = (circuit) => `${pythonDataAnalyticsUrl}/drawCircuit/${circuit}`

const CREATE_UNIT_TEST = `${juliaDataAnalyticsUrl}/createUnitTest`
const RECOMMEND_CIRCUIT = `${juliaDataAnalyticsUrl}/recommendCircuit`

const FETCH_ACCESS_REQUESTS = (userId) =>`${urlMidd}/resourceAccessRequests/${userId}`
const APPROVE_RESOURCE_ACCESS_REQUESTS = (requestId) => `${urlMidd}/resourceAccessRequests/approve/${requestId}`
const REJECT_RESOURCE_ACCESS_REQUESTS = (requestId) => `${urlMidd}/resourceAccessRequests/reject/${requestId}`
const DELETE_RESOURCE_ACCESS_REQUEST = (requestId) => `${urlMidd}/resourceAccessRequests/remove/${requestId}`

const FETCH_SHARED_CLUSTER_EMAILS_BY_USER = (userId) =>`${urlMidd}/sharedClusters/${userId}/emails`

module.exports = {
		ZOHO_AUTH,
    REGISTER_USER,
    LOGOUT_USER,
    GET_ALL_USER,
    SHARED_DETAILS,
    DELETE_USER,
    USER_PROFILE_PATH,
    PATCH_USER_DETAILS,
    RESET_PASSWORD,
    ADD_CLUSTER,
    ADD_PROJECTS,
    ADD_REPORT,
    UPDATE_REPORT,
    READ_CLUSTER_DATA,
    READ_PROJECTS_CLUST,
    READ_REPORTS_PROJ,
    READ_REPORT,
    ADD_RAW_FILE,
    SHARE_CLUSTER,
    UPDATE_SHARE_CLUSTER,
    DELETE_SHARE_CLUSTER,
    DELETE_REPORT,
    RESEND_VERIFICATION,
    READ_BASIC_USER_DATA,
    EDIT_PROJECTS,
    EDIT_CLUSTERS,
    DOWNLOAD_RAW_FILES,
    ADD_TEMPLATE,
    READ_TEMPLATES_PROJ,
    UPDATE_TEMPLATE,
    FILES_TEMPLATE,
    REMOVE_TEMPLATE,
    GET_READ_TEMPLATE,
    BINARY_FILES_DATA_EXTRACTION,
    GET_SVG_CIRCUIT_DRAW,
    SHARE_REPORT,
    UPDATE_SHARE_REPORT,
    DELETE_SHARE_REPORT,
		CREATE_UNIT_TEST,
		RECOMMEND_CIRCUIT,
		REQUEST_ENTITY_SHARE,
		CLUSTER_OWNER_DATA,
		FETCH_ACCESS_REQUESTS,
		APPROVE_RESOURCE_ACCESS_REQUESTS,
		REJECT_RESOURCE_ACCESS_REQUESTS,
		DELETE_RESOURCE_ACCESS_REQUEST,
		READ_USER_NAME,
		MANAGE_CLUSTER_ARCHIVAL,
		MANAGE_CLUSTER_FAVOURITE,
		OPT_OUT_SHARED_CLUSTER,
		FETCH_SHARED_CLUSTER_EMAILS_BY_USER
}
